import "./App.css";
import React from "react";
import MessengerCustomerChat from 'react-messenger-customer-chat';
import emailjs from "emailjs-com";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import Footer from "../src/Footer";
import image1 from "./stylemart/WhatsApp Image 2021-04-07 at 11.31.16 PM.jpeg";
import image3 from "./stylemart/162463678_108682654639590_8839739053850919787_n.jpg";
import image4 from "./stylemart/169413449_119344280240094_1810795263236791857_n.jpg";
import image5 from "./stylemart/WhatsApp Image 2021-04-07 at 11.31.31 PM.jpeg";
import image6 from "./stylemart/162727358_108674267973762_4668352915600317345_n.jpg";
import image7 from "./stylemart/WhatsApp Image 2021-04-07 at 11.31.33 PM.jpeg";
import image9 from "./stylemart/WhatsApp Image 2021-04-07 at 11.31.35 PM.jpeg";
import image11 from "./stylemart/WhatsApp Image 2021-04-07 at 11.31.37 PM.jpeg";
import image13 from "./stylemart/WhatsApp Image 2021-04-07 at 11.31.39 PM.jpeg";
import image14 from "./stylemart/WhatsApp Image 2021-04-07 at 11.31.40 PM (1).jpeg";
import image15 from "./stylemart/WhatsApp Image 2021-04-07 at 11.31.39 PM (1).jpeg";
import image16 from "./stylemart/1.jpg";
import image17 from "./stylemart/2.jpg";
import image18 from "./stylemart/3.jpg";
import image19 from "./stylemart/4.jpg";
import image20 from "./stylemart/5.jpg";
import image21 from "./stylemart/6.jpg";
import image23 from "./stylemart/8.jpg";
import image24 from "./stylemart/9.jpg";
import image25 from "./stylemart/11.jpeg";
import image26 from "./stylemart/10.jpg";
import image27 from "./stylemart/12.jpeg";
import Logo from "./stylemart/Logo.png";
import facebook from "./stylemart/facebook.svg";
import whatsapp from "./stylemart/whatsapp.svg";
import instagram from "./stylemart/instagram.svg";
import hb1 from "./stylemart/hb104.jpg";
import hb2 from "./stylemart/162381462_108636487977540_5385674407919614888_n.jpg";
import hb3 from "./stylemart/162439417_108640001310522_2217681692066607400_n.jpg";
import hb4 from "./stylemart/162521687_108633284644527_3349228963391439343_n.jpg";
import hb5 from "./stylemart/167399319_118106233697232_6971585097702603053_n.jpg";
import hb7 from "./stylemart/166825419_116743077166881_4298800367171544817_n.jpg";
import hb8 from "./stylemart/162532851_108630724644783_8235078000908314034_n.jpg";
import banner1 from "./stylemart/banner1.jpg";
import banner2 from "./stylemart/banner2.jpg";
import banner3 from "./stylemart/banner3.jpg";

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      product1: false,
      product2: false,
      product3: false,
      product4: false,
      product5: false,
      product6: false,
      product7: false,
      product8: false,
      product9: false,
      product10: false,
      product11: false,
      product12: false,
      product13: false,
      product14: false,
      product15: false,
      product16: false,
      product17: false,
      product18: false,
      product19: false,
      product20: false,
      product21: false,
      product22: false,
      product23: false,
      product24: false,
      product25: false,
      product26: false,
      product27: false,
      product28: false,
      product29: false,
      product30: false,
    };
  }
  HandleModelProduct1() {
    this.setState({ product1: !this.state.product1 });
  }
  HandleModelProduct2() {
    this.setState({ product2: !this.state.product2 });
  }
  HandleModelProduct3() {
    this.setState({ product3: !this.state.product3 });
  }
  HandleModelProduct4() {
    this.setState({ product4: !this.state.product4 });
  }
  HandleModelProduct5() {
    this.setState({ product5: !this.state.product5 });
  }
  HandleModelProduct6() {
    this.setState({ product6: !this.state.product6 });
  }
  HandleModelProduct7() {
    this.setState({ product7: !this.state.product7 });
  }
  HandleModelProduct8() {
    this.setState({ product8: !this.state.product8 });
  }
  HandleModelProduct9() {
    this.setState({ product9: !this.state.product9 });
  }
  HandleModelProduct10() {
    this.setState({ product10: !this.state.product10 });
  }
  HandleModelProduct11() {
    this.setState({ product11: !this.state.product11 });
  }
  HandleModelProduct12() {
    this.setState({ product12: !this.state.product12 });
  }
  HandleModelProduct13() {
    this.setState({ product13: !this.state.product13 });
  }
  HandleModelProduct14() {
    this.setState({ product14: !this.state.product14 });
  }
  HandleModelProduct15() {
    this.setState({ product15: !this.state.product15 });
  }
  HandleModelProduct16() {
    this.setState({ product16: !this.state.product16 });
  }
  HandleModelProduct17() {
    this.setState({ product17: !this.state.product17 });
  }
  HandleModelProduct18() {
    this.setState({ product18: !this.state.product18 });
  }
  HandleModelProduct19() {
    this.setState({ product19: !this.state.product19 });
  }
  HandleModelProduct20() {
    this.setState({ product20: !this.state.product20 });
  }
  HandleModelProduct21() {
    this.setState({ product21: !this.state.product21 });
  }
  HandleModelProduct22() {
    this.setState({ product22: !this.state.product22 });
  }
  HandleModelProduct23() {
    this.setState({ product23: !this.state.product23 });
  }
  HandleModelProduct24() {
    this.setState({ product24: !this.state.product24 });
  }
  HandleModelProduct25() {
    this.setState({ product25: !this.state.product25 });
  }
  HandleModelProduct26() {
    this.setState({ product26: !this.state.product26 });
  }
  HandleModelProduct27() {
    this.setState({ product27: !this.state.product27 });
  }
  HandleModelProduct28() {
    this.setState({ product28: !this.state.product28 });
  }
  HandleModelProduct29() {
    this.setState({ product29: !this.state.product29 });
  }
  HandleModelProduct30() {
    this.setState({ product30: !this.state.product30 });
  }


  render() {
    function sendEmail(e) {
      e.preventDefault();
        emailjs
          .sendForm(
            "service_jd57wlk",
            "order",
            e.target,
            "user_srGuLmi5bWb010vuMbKKC"
          )
          .then(
            (result) => {
              console.log(result.text);
            },
            (error) => {
              console.log(error.text);
            }
        );
        alert("You will receive a confirmation call Soon Thank You! ");
      e.target.reset();
      
    }
  
    
    return (
      <div className="App">
        <header className="App-header">
          <MessengerCustomerChat
    pageId="105458858351550"
    appId="588889365150764"
    
  />
          
          <div className="maindiv">
            <div class="social-icons">
              <a href="https://www.facebook.com/stylemartpakistan">
                <img className="fblogo" src={facebook} alt="Not found" />
              </a>
              <a href="https://www.instagram.com/style.martpakistan/">
                <img className="fblogo" src={instagram} alt="Not found" />
              </a>

              <img className="fblogo" src={whatsapp} alt="Not found" />

              <p>+923009492821 +923205790799</p>
            </div>
            <div className="logo">
              <div className="logodiv">
                <img className="logoimage" src={Logo} alt="Not found" />
              </div>
            </div>
            <div className="mainbanner">
              <Carousel>
                <Carousel.Item interval={1800}>
                  <img className="banner" src={banner2} alt="First slide" />
                </Carousel.Item>
                <Carousel.Item interval={1800}>
                  <img className="banner" src={banner1} alt="Second slide" />
                </Carousel.Item>
                <Carousel.Item interval={2000}>
                  <img className="banner" src={banner3} alt="Third slide" />
                </Carousel.Item>
              </Carousel>
            </div>
            <div className="TitleBanner">
              <h1>CLUTCHES</h1>
            </div>
            <div className="Products">
              <div className="product1">
                <img
                  className="productimage"
                  src={image1}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct1();
                  }}
                />
                Ajrak Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product1}
                    onHide={() => this.HandleModelProduct1()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Ajrak Design</Modal.Title>

                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Ajrak Design"> Ajrak Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="black">Black</option>
                              <option value="Skin">Skin</option>
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>

              <div className="product1">
                <img
                  className="productimage"
                  src={image5}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct2();
                  }}
                />
                Block Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product2}
                    onHide={() => this.HandleModelProduct2()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Block Design</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Block Design"> Block Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Black">Black</option>
                              <option value="Copper">Cooper</option>
                              <option value="Silver">Silver</option>
                              <option value="Dark Brown">Dark Brown</option>
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image6}
                  alt="NOT FOUND"
                  onClick={() => this.HandleModelProduct3()}
                />
                Flower Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product3}
                    onHide={() => this.HandleModelProduct3()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Flower Design</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Flower Design"> Flower Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Green with Skin">Green with Skin</option>
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image7}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct4();
                  }}
                />
                Cheetah Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product4}
                    onHide={() => this.HandleModelProduct4()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Cheetah Design</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Cheetah Design"> Cheetah Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="black cheetah">Cheetah Print</option>
                              <option value="black zebra">Zebra Print</option>
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>

              <div className="product1">
                <img
                  className="productimage"
                  src={image9}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct5();
                  }}
                />
                Truck Art Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product5}
                    onHide={() => this.HandleModelProduct5()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Truck Art Design</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Truck Art Design"> Truck Art Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="blue">Blue</option>
                              <option value="green">Green</option>
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image3}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct6();
                  }}
                />
                Gucci Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product6}
                    onHide={() => this.HandleModelProduct6()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Gucci Design</Modal.Title>
                    </Modal.Header>

                   <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="GucciDesign"> Gucci Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Pink">Pink</option>
                              <option value="Light Brown">Light Brown</option>
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image4}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct7();
                  }}
                />
                Check Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product7}
                    onHide={() => this.HandleModelProduct7()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Check Design</Modal.Title>
                    </Modal.Header>

                     <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Check Design"> Check Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Plum">Plum with Black</option>
                              <option value="Skin">Skin with Black</option>
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>

              <div className="product1">
                <img
                  className="productimage"
                  src={image11}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct8();
                  }}
                />
                Spring Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product8}
                    onHide={() => this.HandleModelProduct8()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Spring Design</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Spring Design"> Spring Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Pink">Pink</option>
                              <option value="Blue">Blue</option>
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>

              <div className="product1">
                <img
                  className="productimage"
                  src={image13}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct9();
                  }}
                />
                Beat Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product9}
                    onHide={() => this.HandleModelProduct9()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Beat Design</Modal.Title>
                    </Modal.Header>

                           <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Beat Design"> Beat Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Pink">Pink</option>
                              
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image14}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct10();
                  }}
                />
                Polka Dot Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product10}
                    onHide={() => this.HandleModelProduct10()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Polka Dot Design</Modal.Title>
                    </Modal.Header>

                           <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Polka Dot Design"> Polka Dot Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Pink">Pink</option>
                              <option value="Black">Black</option>
                              <option value="Red">Red</option>
                              <option value="Skin">Skin</option>
                              <option value="Brown">Brown</option>
                              <option value="SeaGreen">Sea Green</option>
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image15}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct11();
                  }}
                />
                Leather Design
                <br />
                RS:450
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product11}
                    onHide={() => this.HandleModelProduct11()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Leather Design</Modal.Title>
                    </Modal.Header>

                  <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Leather Design"> Leather Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Grey">Grey</option>
                              <option value="Camel Brown">Camel Brown</option>
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image16}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct12();
                  }}
                />
                Abstract Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product12}
                    onHide={() => this.HandleModelProduct12()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Abstract Design</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Abstract Design"> Abstract Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="as in pic">As in Picture</option>
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image17}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct13();
                  }}
                />
                Fashion Vol 1
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product13}
                    onHide={() => this.HandleModelProduct13()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Fashion Vol 1</Modal.Title>
                    </Modal.Header>
                     <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Fashion Vol 1"> Fashion Vol 1</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Silver">Silver</option>
                              <option value="Golden">Golden</option>
                              <option value="Dark Brown">Dark Brown</option>
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image18}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct14();
                  }}
                />
                Fashion Vol 2
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product14}
                    onHide={() => this.HandleModelProduct14()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Fashion Vol 2</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Fashion Vol 2"> Fashion Vol 2</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Skin">Skin</option>
                              <option value="Red">Red</option>
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image19}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct15();
                  }}
                />
                Newspaper Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product15}
                    onHide={() => this.HandleModelProduct15()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Newspaper Design</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Newspaper Design"> Newspaper Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="White">White</option>
                              
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image20}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct16();
                  }}
                />
                Stripes Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product16}
                    onHide={() => this.HandleModelProduct16()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Stripes Design</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Stripes Design"> Stripes Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="As in Picture">As in Picture</option>
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image21}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct17();
                  }}
                />
                Snake Skin Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product17}
                    onHide={() => this.HandleModelProduct17()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Snake Skin Design</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Snake Skin Design"> Snake Skin Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Blue">Blue</option>
                              <option value="Dark Brown">Dark Brown</option>
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image23}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct18();
                  }}
                />
                Ball Ribbon Design
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product18}
                    onHide={() => this.HandleModelProduct18()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Ball Ribbon Design</Modal.Title>
                    </Modal.Header>

                   <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Ball Ribbon Design"> Ball Ribbon Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="As in Picture">As in Picture</option>
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image24}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct19();
                  }}
                />
                Abstract Design 2
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product19}
                    onHide={() => this.HandleModelProduct19()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Abstract Design 2</Modal.Title>
                    </Modal.Header>

                   <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Abstract Design 2"> Abstract Design 2</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="As in Picture">As in Picture</option>
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image25}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct20();
                  }}
                />
                Fashion Vol 3
                <br />
                RS:350
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product20}
                    onHide={() => this.HandleModelProduct20()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Fashion Vol 3</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Fashion Vol 3">Fashion Vol 3</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Peach">Peach</option>
                              <option value="Pink">Pink</option>
                              <option value="Grey">Grey</option>
                              <option value="Blue">Blue</option>
                              <option value="Sea Green">Sea Green</option>
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image26}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct21();
                  }}
                />
                Fancy Bridal Design 1
                <br />
                RS:750
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product21}
                    onHide={() => this.HandleModelProduct21()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Fancy Bridal Design 1</Modal.Title>
                    </Modal.Header>

                   <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Fancy Bridal Design 1"> Fancy Bridal Design 1</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="As in Picture">As in Picture</option>
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={image27}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct22();
                  }}
                />
                Fancy Bridal Design 2
                <br />
                RS:750
                <br />
                Free Delivery
                <>
                  <Modal
                    show={this.state.product22}
                    onHide={() => this.HandleModelProduct22()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Fancy Bridal Design 2</Modal.Title>
                    </Modal.Header>

                   <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Fancy Bridal Design 2"> Fancy Bridal Design 2</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="As in Picture">As in Picture</option>
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>

              <div className="TitleBanner">
                <h1>HAND BAGS</h1>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={hb1}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct23();
                  }}
                />
                Chain Ring Design
                <br />
                RS:1400
                <br />
                Delivery:150 only
                <>
                  <Modal
                    show={this.state.product23}
                    onHide={() => this.HandleModelProduct23()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Chain Ring Design</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Chain Ring Design">Chain Ring Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Plum with Black">Plum with Black</option>
                              <option value="Redwith Black">Red with Black</option>
                              <option value="Yellow with Black">Yellow with Black</option>
                              <option value="Blue with Black">Blue with Black</option>
                              <option value="Brown with Black">Brown with Black</option>
                              <option value="Grey with Black">Grey with Black</option>
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={hb2}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct24();
                  }}
                />
                Standard Design
                <br />
                RS:1200
                <br />
                Delivery:150 only
                <>
                  <Modal
                    show={this.state.product24}
                    onHide={() => this.HandleModelProduct24()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Standard Design</Modal.Title>
                    </Modal.Header>

                   <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Standard Design">Standard Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Grey">Grey</option>
                              <option value="White">White</option>
                              <option value="Black">Black</option>
                              <option value="Silver">Silver</option>
                              <option value="Brwon">Brown</option>
                              <option value="Maroon">Maroon</option>
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={hb3}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct25();
                  }}
                />
                Classic Collection
                <br />
                RS:1500
                <br />
                Delivery:150 only
                <>
                  <Modal
                    show={this.state.product25}
                    onHide={() => this.HandleModelProduct25()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Classic Collection</Modal.Title>
                    </Modal.Header>

                  <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Classic Design">Classic Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Grey with Plum Straps">Grey with Plum Straps</option>
                              <option value="Sea Green with Peach Straps">Sea Green with Peach Straps</option>
                              <option value="Plum with Grey Straps">Plum with Grey Straps</option>
                              <option value="Peach with Plum Straps">Peach with Plum Straps</option>
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={hb4}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct26();
                  }}
                />
                Front Ring Design
                <br />
                RS:1300
                <br />
                Delivery:150 only
                <>
                  <Modal
                    show={this.state.product26}
                    onHide={() => this.HandleModelProduct26()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Front Ring Design</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Front Ring Design">Front Ring Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Grey">Grey</option>
                              <option value="White">White</option>
                              <option value="Black">Black</option>
                              <option value="Brwon">Brown</option>
                              
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={hb5}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct27();
                  }}
                />
                Elegant Design
                <br />
                RS:1500
                <br />
                Delivery:150 only
                <>
                  <Modal
                    show={this.state.product27}
                    onHide={() => this.HandleModelProduct27()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Elegant Design</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Elegant Design">Elegant Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Blue">Blue</option>
                              <option value="Skin">Skin</option>
                              <option value="Red">Red</option>
                              <option value="Brwon">Brown</option>
                              <option value="Firozi">Firozi</option>
                              
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
             
              <div className="product1">
                <img
                  className="productimage"
                  src={hb7}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct29();
                  }}
                />
                Fashion Edition <br />
                RS:1600
                <br />
                Delivery:150 only
                <>
                  <Modal
                    show={this.state.product29}
                    onHide={() => this.HandleModelProduct29()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Fashion Edition</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Fashion Edition">Fashion Edition</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Grey">Grey</option>
                              <option value="Sea Green">Sea Green</option>
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
              <div className="product1">
                <img
                  className="productimage"
                  src={hb8}
                  alt="NOT FOUND"
                  onClick={() => {
                    this.HandleModelProduct30();
                  }}
                />
                Chain Ring Design 2 <br />
                RS:1500
                <br />
                Delivery:150 only
                <>
                  <Modal
                    show={this.state.product30}
                    onHide={() => this.HandleModelProduct30()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Chain Ring Design 2</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <label className="infoprompt">Please add Full information</label>
                      <form id="form"onSubmit={sendEmail}>
                        <div className="row pt-5 mx-auto">
                          <div className="col-8 form-group mx-auto">
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Contact"
                              name="contact"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="address"
                            />
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Quantity"
                              name="qty"
                            />
                            <br></br>
                            <label for="design">Confirm Design</label>
                            <select name="design">
                              <option value="Elegant Design">Elegant Design</option>
                            </select>
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <label for="color">Choose color </label>
                            <select name="color">
                              <option value="Blue">Blue</option>
                              <option value="Grey">Grey</option>
                              <option value="Red">Red</option>
                              <option value="AS in Picture">As in Picture</option>
                              
                              
                        
                            </select>
                            
                          </div>
                          <div className="col-8 form-group pt-2 mx-auto">
                            <textarea
                              className="form-control"
                              id=""
                              cols="10"
                              rows="2"
                              placeholder="Your Order Note"
                              name="note"
                            ></textarea>
                          </div>
                          <div className="col-5 pt-3 mx-auto">
                            <input
                              type="submit"
                              className="btn btn-info"
                              value="Send Order"
                            ></input>
                          </div>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              </div>
            </div>
          </div>
        </header>
        <Footer />
      </div>
  
    );
  }
}

export default App;
